import Component from './Component';
import { swiffyslider } from 'swiffy-slider';
import { getSiteCode, getStoredBlogs } from "../lib/RecentBlogsHelper";


export default class RecentBlogViewsCarousel extends Component {
  load() {

    console.log('RecentBlogViewsCarousel');

    const siteCode = getSiteCode();

    // Get from Storage
    const recentBlogsArray = getStoredBlogs(siteCode);
    // console.log('recentBlogsArray YY:::', recentBlogsArray);


    console.log('recentBlogsArray:::', recentBlogsArray);

    // When module is present display cards using data from store.
    // If no recent views use JS to delete Module HTML from DOM.

    // Create DOM fragment as SwiffySlider carousel.
    createFragment(recentBlogsArray);


    // Delete module from DOM if no recentBlogsViewed.
    if (recentBlogsArray.length < 1) {
      document.querySelectorAll('.recentblogviews-section').forEach(el => el.remove());
    }



    super.load();

  }
}







// create Fragment
function createFragment(array) {

  const recentEls = document.querySelectorAll('.recentblogviews-section');

  // Check if element exists
  if (recentEls.length < 1) {
    console.log('no RecentBlogViews module on page.');
    return;
  }

  // as much Bootstrap styling as possible

  let itemsChunk = '';

  for (const item in array.reverse()) {
    if (Object.hasOwnProperty.call(array, item)) {
      const title = array[item].title;
      const imageSmall = resizeImage(array[item].image, 'small');
      const imageLarge = resizeImage(array[item].image, 'large');
      const pageUrl = array[item].url;
      const seenDate = array[item].seenDateHuman;
      const domain = window.location.origin;
      const placeholder = `${domain}/static/images/3x2grey.gif`;

      itemsChunk = itemsChunk + `
        <li class="recentblog textVisible slide-visible">
          <a href="${pageUrl}" target="_blank" data-date="${seenDate}"
            class="recentblog__link  card align-content-stretch">
              <img class="recentblog__image lazy card-img-top"
                width="540" height="350"
                data-srcset="${imageLarge} 540w, ${imageSmall} 300w"
                sizes="(max-width: 992px) 540px, 300px"
                src="${placeholder}"
                alt="${title}">
              <div class="recentblog__caption card-body">
                  <span class="recentblog__title card-title">${title}</span>
              </div>
          </a>
        </li>
        `;
    }
  }


  const HTMLchunk = `
    <style>
    .recentblog__image{height: fit-content;}
    </style>
    <div class="recentblogviews__container container recentblogviews--swiffy-settings swiffy-slider indicatorsFalse slider-item-show4 slider-item-nogap slider-indicators-outside slider-indicators-round slider-indicators-dark slider-nav-page slider-nav-round slider-nav-animation slider-nav-animation-fadein slider-item-first-visible">

      <ul class="recentblogviews__list slider-container">
          ${itemsChunk}
      </ul>

      <button type="button" class="slider-nav slider-nav-prev" aria-label="previous slide"></button>
            <button type="button" class="slider-nav slider-nav-next" aria-label="next slide"></button>

      <div class="slider-indicators">
        <button class="active" aria-label="active slide"></button>
        <button></button>
        <button></button>
      </div>

    </div>
  `;
  const wrapperNode = document.createElement('div');
  wrapperNode.innerHTML = HTMLchunk;

  const firstRecentEl = recentEls[0];
  // append to DOM
  firstRecentEl.append(wrapperNode);
  console.log('recentblogviews Fragment added to DOM');

  global.swiffyslider = swiffyslider;  // add swiffyslider function to the global/window object
  global.swiffyslider.init();          // start swiffyslider
  console.log('init swiffyslider: ');

}


function resizeImage(imagePath, size) {
  const matchStr = '?w=1100&width=1100';
  const smallStr = '?width=300&height=188&mode=crop'
  const defaultStr = '?width=576&height=360&mode=crop';
  const newStr = (size === 'small') ? smallStr : defaultStr;
  const newPath = imagePath.split(matchStr)[0] + newStr;
  // if (imagePath.length > 0 && imagePath.includes(matchStr)) {
  //   //
  //   console.log('does contain substring.');

  // }
  console.log('newPath: ', newPath);

  return newPath;
}
